const BASE_API_URL = import.meta.env.VITE_REACT_APP_BASE_API_URL;
// const BASE_API_URL = 'https://api.djkip.com'; //uncomment this to connect to prod BE

import { trigger } from './utils/events';
import { auth } from './firebase';

export default class ApiClient {
  constructor() {
    this.base_url = BASE_API_URL + '/api';
  }

  async request(options) {
    // Skip auth for user registration
    if (options.url === '/users' && options.method === 'POST') {
      return this.requestInternal(options);
    }

    // Get token from localStorage for internal auth
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${accessToken}`,
      };
      return this.requestInternal(options);
    }

    // Fall back to Firebase auth if no internal token
    const user = auth.currentUser;
    if (!user) {
      return {
        ok: false,
        status: 401,
        body: { message: 'Not authenticated' },
      };
    }

    const token = await user.getIdToken(true);
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };

    return this.requestInternal(options);
  }

  async requestInternal(options) {
    let query = new URLSearchParams(options.query || {}).toString();
    if (query !== '') {
      query = '?' + query;
    }

    let response;
    try {
      response = await fetch(this.base_url + options.url + query, {
        method: options.method,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        body: options.body ? JSON.stringify(options.body) : null,
      });
    } catch (error) {
      response = {
        ok: false,
        status: 500,
        json: async () => {
          return {
            code: 500,
            message: 'The server is unresponsive',
            description: error.toString(),
          };
        },
      };
    }

    return {
      ok: response.ok,
      status: response.status,
      body: response.status !== 204 ? await response.json() : null,
    };
  }

  async requestUnauthenticated(options) {
    let query = new URLSearchParams(options.query || {}).toString();
    if (query !== '') {
      query = '?' + query;
    }

    let response;
    try {
      response = await fetch(this.base_url + options.url + query, {
        method: options.method,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
        },
        body: options.body ? JSON.stringify(options.body) : null,
      });
    } catch (error) {
      response = {
        ok: false,
        status: 500,
        json: async () => {
          return {
            code: 500,
            message: 'The server is unresponsive',
            description: error.toString(),
          };
        },
      };
    }

    return {
      ok: response.ok,
      status: response.status,
      body: response.status !== 204 ? await response.json() : null,
    };
  }

  async get(url, query, options) {
    return this.request({ method: 'GET', url, query, ...options });
  }

  async post(url, body, options) {
    return this.request({ method: 'POST', url, body, ...options });
  }

  async put(url, body, options) {
    return this.request({ method: 'PUT', url, body, ...options });
  }

  async delete(url, options) {
    return this.request({ method: 'DELETE', url, ...options });
  }

  async logout() {
    localStorage.removeItem('accessToken');
    trigger('logout');
  }

  isAuthenticated() {
    return auth.currentUser !== null;
  }
}
